import { render, staticRenderFns } from "./OverviewTabs.vue?vue&type=template&id=e118c9ae&scoped=true"
import script from "./OverviewTabs.vue?vue&type=script&lang=js"
export * from "./OverviewTabs.vue?vue&type=script&lang=js"
import style0 from "./OverviewTabs.vue?vue&type=style&index=0&id=e118c9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e118c9ae",
  null
  
)

export default component.exports